import axios from 'axios';

export default axios.create({
    baseURL:"https://ngs.adv.br/"
    //baseURL:"http://localhost/ngsAdvogada/"
});